<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs10>
        <v-card class="text-xs-center">

          <!-- Título da tela -->
          <basic-toolbar :title="'Liberar preenchimento do relatório técnico final'"></basic-toolbar>

          <v-card-text>
            <v-form v-model="formularioValido" ref="form">
              <v-container>

                <!-- Dialog de confirmação -->
                <v-dialog v-model="dialog" width="650">
                  <v-card>
                    <v-card-title class="headline grey lighten-2" primary-title>
                      Confirma a liberação do preenchimento do relatório?
                    </v-card-title>
                    <v-card-text>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-btn color="primary" text @click="dialog = false">Não</v-btn>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" text @click="liberarRelatorio">Sim</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                <!-- Título -->
                <v-layout row wrap justify-space-between>
                  <v-flex xs12>
                    <v-text-field readonly label="Título" :value="this.projeto.titulo"></v-text-field>
                  </v-flex>
                </v-layout>

                <!-- Número e Situação -->
                <v-layout row wrap justify-space-between>

                  <!-- Número -->
                  <v-flex xs6>
                    <v-text-field readonly label="Número" :value="this.projeto.idProjeto"></v-text-field>
                  </v-flex>

                  <!-- Situação -->
                  <v-flex xs6>
                    <v-text-field readonly label="Situação" :value="this.projeto.situacao.descricao"></v-text-field>
                  </v-flex>

                </v-layout>

                <!-- Data de início e Data de conclusão -->
                <v-layout row wrap justify-space-between>

                  <!-- Data de início -->
                  <v-flex xs6>
                    <v-text-field readonly label="Data de início" :value="dates.format(this.projeto.dataInicio)"></v-text-field>
                  </v-flex>

                  <!-- Data de conclusão -->
                  <v-flex xs6>
                    <v-text-field readonly label="Data de conclusão" :value="dates.format(this.projeto.dataConclusao)"></v-text-field>
                  </v-flex>

                </v-layout>

                <p class="mt-3"></p>

              </v-container>
            </v-form>
            <v-divider></v-divider>

            <!-- Botões "Cancelar" e "Liberar" -->
            <v-card-actions>

              <!-- Cancelar -->
              <v-btn color="primary" text @click="cancelar">Cancelar</v-btn>
              
              <v-spacer></v-spacer>

              <!-- Liberar -->
              <v-btn color="primary" text @click="dialog = true" :disabled="!formularioValido">Liberar</v-btn>

            </v-card-actions>

          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import ToolTip from '@/components/app-layouts/app-tooltip/tooltip'
  import DataMenu from '@/components/c-date-menu'
  import TextArea from '@/components/c-textarea'
  import projetos from '@/utils/projetos'
  import dates from '@/utils/dates'
  import { mapActions } from 'vuex'

  export default {
    props: ['idProjeto'],
    data: () => ({
      dialog: false,
      formularioValido: false,
      dates: dates,
      projeto: {
        situacao: {},
        tipoPublico: {},
        classificacoesPrimariaSecundaria: [{}, {}]
      }
    }),
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
      // Cancelar.
      cancelar: function () {
        this.$router.go(-1)
      },
      // Endpoint para liberar o preenchimento do relatório técnico final.
      liberarRelatorio: function () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Liberando preenchimento do relatório técnico final...' })
        projetos.postLiberarRelatorioFinal(this.idProjeto)
        .then(response => {
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
          this.$router.go(-1)
        })
        .catch(error => {
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Liberando preenchimento do relatório técnico final...' })
        })
      }
    },
    mounted () {
      // Carrega ação de extensão.
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ação de extensão...' })
      projetos.getProjeto(this.idProjeto)
      .then(response => {
        this.projeto = response.data
        this.devolucao.classificacaoSecundaria = this.projeto.classificacaoSecundaria
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ação de extensão...' })
      })
    },
    components: {
      'basic-toolbar': BasicToolbar,
      'tooltip': ToolTip,
      'c-date-menu': DataMenu,
      'c-textarea': TextArea
    }
  }
</script>

<style lang="css">
  .menu {
    display: block !important;
  }

  .no-resize div textarea{
    resize: none;
  }
  .input-group__icon-cb {
    cursor: pointer !important;
  }
</style>



// WEBPACK FOOTER //
// liberar-relatorio.vue?5e75ae02